import { render, staticRenderFns } from "./SubmittedPreview.vue?vue&type=template&id=5783de34&scoped=true"
import script from "./SubmittedPreview.vue?vue&type=script&lang=js"
export * from "./SubmittedPreview.vue?vue&type=script&lang=js"
import style0 from "./SubmittedPreview.vue?vue&type=style&index=0&id=5783de34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5783de34",
  null
  
)

export default component.exports